import NotificationBellFill from './NotificationBellFill';

export default NotificationBellFill;
